import { render, staticRenderFns } from "./Green.vue?vue&type=template&id=70c84388&scoped=true&"
import script from "./Green.vue?vue&type=script&lang=js&"
export * from "./Green.vue?vue&type=script&lang=js&"
import style0 from "./Green.vue?vue&type=style&index=0&id=70c84388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c84388",
  null
  
)

export default component.exports